import React from 'react';
import { mockBillwiseDues, mockMembers, formatCurrency } from '../../../services/mockData';

const BillwiseDues = () => {
  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Members Reports <span>/ Billwise Dues Report</span></div>
        <h2>BillWise Dues Report</h2>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>Select Ledger</label>
          <select className="form-control">
            <option>Abhishek Singh (bhoomi F0102-F0102)</option>
            {mockMembers.map(m => <option key={m.flatNo}>{m.memberName} ({m.flatNo})</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Summary Type</label>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'center', paddingTop: '4px' }}>
            <label style={{ display: 'flex', gap: '4px', alignItems: 'center', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
              <input type="radio" name="summary" defaultChecked /> All Summary
            </label>
            <label style={{ display: 'flex', gap: '4px', alignItems: 'center', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>
              <input type="radio" name="summary" /> Summary
            </label>
          </div>
        </div>
        <div className="form-group" style={{ marginLeft: 'auto', justifyContent: 'flex-end' }}>
          <div className="btn-group">
            <button className="btn btn-warning btn-sm">🖨️ Print</button>
            <button className="btn btn-success btn-sm">📊 Export To Excel</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="report-header">
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>
            Billwise Dues Statement: 2025-2026<br />
            <b>Abhishek Singh – bhoomi F0102-F0102</b>
          </p>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Particulars</th>
                <th>Type</th>
                <th className="amount">Dr</th>
                <th className="amount">Cr</th>
                <th className="amount">Closing</th>
              </tr>
            </thead>
            <tbody>
              {mockBillwiseDues.map((b, i) => (
                <tr key={i}>
                  <td>{b.date}</td>
                  <td>{b.particulars}</td>
                  <td><span className={`badge ${b.type.includes('OPN') ? 'badge-secondary' : b.type === 'SUPP' ? 'badge-warning' : 'badge-primary'}`}>{b.type}</span></td>
                  <td className="amount dr">{b.dr > 0 ? formatCurrency(b.dr) : ''}</td>
                  <td className="amount cr">{b.cr > 0 ? formatCurrency(b.cr) : ''}</td>
                  <td className={`amount ${b.closing < 0 ? 'cr' : 'dr'}`} style={{ fontWeight: '700' }}>
                    {formatCurrency(Math.abs(b.closing))}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3} style={{ textAlign: 'right' }}>Balance</td>
                <td className="amount dr">{formatCurrency(mockBillwiseDues.reduce((s, b) => s + b.dr, 0))}</td>
                <td className="amount cr">{formatCurrency(mockBillwiseDues.reduce((s, b) => s + b.cr, 0))}</td>
                <td className="amount" style={{ fontWeight: '800' }}>
                  {formatCurrency(Math.abs(mockBillwiseDues[mockBillwiseDues.length - 1]?.closing || 0))}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BillwiseDues;
